import { environment } from "src/environments/environment";
import { LoginService } from "src/app/login/login.service";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class TaggingService {
  constructor(public _http: HttpClient, public loginService: LoginService) {}

  private getCurrentRegistrationUrl(): string | null {
    if (typeof window === "undefined") {
      return null;
    }

    return window.location.href;
  }

  tagAnonymousUser(
    email: string,
    firstName: string,
    lastName: string,
    firmSize: string,
    leadSource: string,
    ownerPhone: string
  ) {
    const registrationUrl = this.getCurrentRegistrationUrl();

    return this._http.post(
      `${environment.apiUrl}/integration/common/tag/anonymous`,
      {
        email,
        firstName,
        lastName,
        firmSize,
        leadSource,
        ownerPhone,
        registrationUrl,
      }
    );
  }

  tagAnonymousUserPromise(
    email: string,
    firstName: string,
    lastName: string,
    firmSize: string,
    leadSource: string,
    ownerPhone: string
  ) {
    const registrationUrl = this.getCurrentRegistrationUrl();

    return this._http
      .post(`${environment.apiUrl}/integration/common/tag/anonymous`, {
        email,
        firstName,
        lastName,
        firmSize,
        leadSource,
        ownerPhone,
        registrationUrl,
      })
      .toPromise();
  }
}
